import script from "./ButtonArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonArrow.vue?vue&type=script&setup=true&lang=js"

import "./ButtonArrow.vue?vue&type=style&index=0&id=5cb0acca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb0acca"]])

export default __exports__